import axios from '@/api/config.js'
import {
  typingSingleLessonsAPI,
  typingCombineLessonsAPI,
  typingOtherInformationAPI,
  typingSingleBasicLessonAPI,
  typingSingleIntermediateLessonAPI,
  typingSingleAdvancedLessonAPI,
  typingCombineIntermediateLessonAPI,
  typingCombineAdvancedLessonAPI,
  submitTypingSingleBasicRecordAPI,
  submitTypingSingleIntermediateRecordAPI,
  submitTypingCombineIntermediateRecordAPI
} from '@/api/typingAPI'
import {
  // refreshTokenAPI,
  firstPracticedAPI
} from '@/api/authAPI'

const state = {
  typingSingleFetching: false,
  typingCombineFetching: false,
  typingSingleLessonList: [],
  typingCombineLessonList: [],
  lessonOtherInformation: null,
  submitting: false,
  fetching: false,
  finish: false
}

const getters = {
}

const mutations = {
  setTypingSingleFetching (state, status) {
    state.typingSingleFetching = status
  },
  setTypingCombineFetching (state, status) {
    state.typingCombineFetching = status
  },
  setTypingSingleLessonLists (state, data) {
    state.typingSingleLessonList = data
  },
  setTypingCombineLessonLists (state, data) {
    state.typingCombineLessonList = data
  },
  setLessonOtherInformation (state, payload) {
    state.lessonOtherInformation = payload
  },
  setSubmitting (state, status) {
    state.submitting = status
  },
  setFetching (state, status) {
    state.fetching = status
  },
  setFinish (state, status) {
    state.finish = status
  }
}

const actions = {
  fetchTypingSingleLessonLists: ({ commit }, payload) => {
    commit('setTypingSingleFetching', true)
    return new Promise((resolve, reject) => {
      axios.post(typingSingleLessonsAPI)
        .then((response) => {
          commit('setTypingSingleLessonLists', response.data)
          commit('setTypingSingleFetching', false)
          resolve('OK')
        }).catch((err) => {
          reject(err)
        })
    })
  },
  fetchTypingCombineLessonLists: ({ commit }, payload) => {
    commit('setTypingCombineFetching', true)
    return new Promise((resolve, reject) => {
      axios.post(typingCombineLessonsAPI)
        .then((response) => {
          console.log('response:', response)
          commit('setTypingCombineLessonLists', response.data)
          commit('setTypingCombineFetching', false)
          resolve('OK')
        }).catch((err) => {
          reject(err)
        })
    })
  },
  // 取得上次一練習的結果（和上次最佳時間）
  fetchLessonOtherInformation: ({ commit }, payload) => {
    commit('setFetching', true)
    return new Promise((resolve, reject) => {
      axios.post(typingOtherInformationAPI, {
        lesson_category: payload.lesson_category,
        lesson_id: payload.lesson_id
      }).then((response) => {
        commit('setLessonOtherInformation', response.data)
        commit('setFetching', false)
        resolve('OK')
      }).catch(() => {})
    })
  },
  startGame ({ commit }) {
    commit('setFinish', false)
  },
  submitTypingSingleBasicRecord ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setSubmitting', true)
      axios.post(submitTypingSingleBasicRecordAPI, {
        lesson_id: payload.lesson_id,
        practice_times: payload.practice_times,
        correct_times: payload.correct_times,
        hit_count: payload.hit_count,
        correct_hit_count: payload.correct_hit_count,
        correct_rate: payload.correct_rate,
        best_used_time: payload.best_used_time,
        complete_used_time: payload.complete_used_time
      }).then((response) => {
        if (localStorage.practicedToday === 'false') {
          axios.post(firstPracticedAPI, {
            email: localStorage.email
          }).then(() => {
            localStorage.practicedToday = true
          })
        }
        commit('setSubmitting', false)
        commit('setFinish', true)
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  submitTypingSingleIntermediateRecord ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setSubmitting', true)
      axios.post(submitTypingSingleIntermediateRecordAPI, {
        lesson_id: payload.lesson_id,
        practice_times: payload.practice_times,
        correct_times: payload.correct_times,
        hit_count: payload.hit_count,
        correct_hit_count: payload.correct_hit_count,
        correct_rate: payload.correct_rate,
        best_used_time: payload.best_used_time,
        complete_used_time: payload.complete_used_time
      }).then((response) => {
        if (localStorage.practicedToday === 'false') {
          axios.post(firstPracticedAPI, {
            email: localStorage.email
          }).then(() => {
            localStorage.practicedToday = true
          })
        }
        commit('setSubmitting', false)
        commit('setFinish', true)
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  submitTypingCombineIntermediateRecord ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setSubmitting', true)
      axios.post(submitTypingCombineIntermediateRecordAPI, {
        lesson_id: payload.lesson_id,
        practice_times: payload.practice_times,
        correct_times: payload.correct_times,
        hit_count: payload.hit_count,
        correct_hit_count: payload.correct_hit_count,
        correct_rate: payload.correct_rate,
        best_used_time: payload.best_used_time,
        complete_used_time: payload.complete_used_time
      }).then((response) => {
        if (localStorage.practicedToday === 'false') {
          axios.post(firstPracticedAPI, {
            email: localStorage.email
          }).then(() => {
            localStorage.practicedToday = true
          })
        }
        commit('setSubmitting', false)
        commit('setFinish', true)
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  fetchLesson ({ commit }, payload) {
    commit('setFetching', true)
    let api = null
    switch (payload.lesson_category) {
      case 'single_basic':
        api = typingSingleBasicLessonAPI
        break
      case 'single_intermediate':
        api = typingSingleIntermediateLessonAPI
        break
      case 'single_advanced':
        api = typingSingleAdvancedLessonAPI
        break
      case 'combine_intermediate':
        api = typingCombineIntermediateLessonAPI
        break
      case 'combine_advanced':
        api = typingCombineAdvancedLessonAPI
        break
    }
    return new Promise((resolve, reject) => {
      axios.post(api, {
        lesson_id: payload.lesson_id
      }).then((response) => {
        commit('setFetching', false)
        resolve(response.data)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
